export const scoreToOption = (score) => ({
	label: score.grade,
	value: score.grade,
});
